import { render, staticRenderFns } from "./single-blacklisted-candidate.vue?vue&type=template&id=378673c1"
import script from "./single-blacklisted-candidate.vue?vue&type=script&lang=js"
export * from "./single-blacklisted-candidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports